// This file used to be in atomic-ui but was removed in nuxt migration so copied implementation here
let observer;
const callbacks = new Map();

function getObserver() {
  if (!observer) {
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const { target } = entry;
          const targetCallback = callbacks.get(target) || {};
          if (entry.isIntersecting) {
            // Element is in the viewport
            // notify the client through the callback
            observer.unobserve(target);
            const { intersectingCallback } = targetCallback;
            if (intersectingCallback) {
              setTimeout(intersectingCallback);
            }
            callbacks.delete(target);
          } else {
            const { notIntheViewCallback } = targetCallback;
            if (notIntheViewCallback) {
              notIntheViewCallback();
            }
          }
        });
      },
      {
        rootMargin: '100px',
      },
    );
  }

  return observer;
}

export default function observe(target, intersectingCallback, notIntheViewCallback) {
  const obs = getObserver();
  callbacks.set(target, { intersectingCallback, notIntheViewCallback });

  obs.observe(target);

  return () => {
    obs.unobserve(target);
    callbacks.delete(target);
  };
}
